(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPerfilDetailController', SSPerfilDetailController);

    SSPerfilDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSPerfil', 'SSActividad', 'SSAsignacion', 'ProgramaEducativo', 'SSProyecto'];

    function SSPerfilDetailController($scope, $rootScope, $stateParams, previousState, entity, SSPerfil, SSActividad, SSAsignacion, ProgramaEducativo, SSProyecto) {
        var vm = this;

        vm.sSPerfil = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSPerfilUpdate', function(event, result) {
            vm.sSPerfil = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
